import { Logo } from "@/components/logo";

const socialLinks = [
  {
    href: "https://www.linkedin.com/company/consumr-ai",
    icon: "https://svgl.app/library/linkedin.svg",
  },
  {
    href: "https://www.youtube.com/@consumrai",
    icon: "https://svgl.app/library/youtube.svg",
  },
  {
    href: "https://x.com/consumresearch",
    icon: "https://svgl.app/library/x.svg",
  },
];

const companyLinks = [
  {
    href: "https://consumr.ai/blog/",
    text: "Blog",
  },
  {
    href: "#about",
    text: "About",
  },
  {
    href: "/contact-us",
    text: "Contact",
  },
  {
    href: "#testimonials",
    text: "Testimonials",
  },
  {
    href: "#pricing",
    text: "Pricing",
  },

  // {
  //   href: "https://consumr.ai/schedule-call/",
  //   text: "Contact",
  // },
  // {
  //   href: "https://consumr.ai/case-study/",
  //   text: "Case Studies",
  // },
  // {
  //   href: "https://consumr.ai/meet-your-ai-twin/",
  //   text: "Meet Your AI Twin",
  // },
];

// const productLinks = [
//   {
//     href: "https://consumr.ai/modules/",
//     text: "Modules",
//   },
//   {
//     href: "https://consumr.ai/pricing/",
//     text: "Pricing",
//   },
//   {
//     href: "https://consumr.ai/solutions/",
//     text: "Solutions",
//   },
// ];

export function Footer() {
  return (
    <footer className="bg-slate-900 text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <Logo className="h-8 w-auto mb-6" color="#ffffff" />
            <p className="text-slate-400 max-w-md leading-relaxed">
              consumr.ai helps brands and agencies understand shifts in the
              consumer landscape through real-time data analysis and AI-powered
              insights.
            </p>
            <div className="mt-6 flex space-x-4">
              {socialLinks.map((link) => (
                <a
                  href={link.href}
                  className="text-slate-400 hover:text-white transition-colors p-2 rounded-full hover:bg-white/10 bg-white/1"
                >
                  <img src={link.icon} className="h-5 w-5 grayscale-100" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {/* 
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Product
            </h3>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()}{" "}
            <a href="https://consumr.ai" className="">
              consumr.ai
            </a>
            . All rights reserved.
          </p>
          <p className="text-sm text-slate-500">
            Powered By{" "}
            <a href="https://profitwheel.com" className="">
              ProfitWheel
            </a>
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a
              href="https://consumr.ai/privacy-policy/"
              className="text-sm text-slate-500 hover:text-white transition-colors"
            >
              Privacy Policy
            </a>
            {/* <a
              href="#"
              className="text-sm text-slate-500 hover:text-white transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="#"
              className="text-sm text-slate-500 hover:text-white transition-colors"
            >
              Cookie Policy
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
